import { ItemDossierDetailModalComponent } from './modals/item-dossier-detail-modal/item-dossier-detail-modal.component';
import { PrivacyGenericoModalComponent } from './modals/privacy-generico-modal/privacy-generico-modal.component';
import { PrivacyGaranteDetenutiModalComponent } from './modals/privacy-garante-detenuti-modal/privacy-garante-detenuti-modal.component';
import { PrivacyGaranteInfanziaModalComponent } from './modals/privacy-garante-infanzia-modal/privacy-garante-infanzia-modal.component';
import { ErrorPageComponent } from './../components/front-office/error-page/error-page.component';
import { SearchDocumentoProtocollatoModalComponent } from './modals/search-documento-protocollato-modal/search-documento-protocollato-modal.component';
import { SearchCarpettaModalComponent } from './modals/search-carpetta-modal/search-carpetta-modal.component';
import { RimandaInIstruttoriaModalComponent } from './modals/rimanda-in-istruttoria-modal/rimanda-in-istruttoria-modal.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RouterModule } from '@angular/router';
import { BadgeComponent } from './components/badge/badge.component';
import { ButtonComponent } from './components/button/button.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TableComponent } from './components/table/table.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { InteractionService } from 'src/app/core/services/interaction.service';
import { MAT_DIALOG_DATA,MatInputModule,MatSelectModule,MatButtonModule,MatCheckboxModule,MatChipsModule, MatDialogModule, MatTableModule, MatSortModule, MatIconModule, MatSnackBarModule, MatProgressSpinnerModule, MatTooltipModule } from '@angular/material';
import { BorderedContainerComponent } from 'src/app/core/components/bordered-container/bordered-container.component';
import { ErrorFormDirective } from '../directives/error-form.directive';
import { ControlErrorContainerDirective } from '../directives/control-error-container.directive';
import { ControlErrorComponent } from '../directives/control-error.component';
//import { ModalComponent } from './components/modal/modal.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { SnackbarService } from './services/snackbar.service';
import { MessageModalComponent } from './modals/messagemodal/messagemodal.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { AlertModalComponent } from './modals/alertModal/alert-modal.component';
import { GeneralConfirmModalComponent } from './modals/general-confirm-modal/general-confirm-modal.component';
import { GeneralEmailModalComponent } from './modals/general-email-modal/general-email-modal.component';
import { GeneralTextareaModalComponent } from './modals/general-textarea-modal/general-textarea-modal.component';
import { AssegnazioneIstruttoreModalComponent } from './modals/assegnazione-istruttore-modal/assegnazione-istruttore-modal.component';
import { LoadingTemplateComponent } from '../directives/components/loading-template/loading-template.component';
import { LoadingDirective } from '../directives/loading.directive';
import { ProcedureAccordionsHeaderPipe } from './pipes/procedure-accordions-header.pipe';
import { SearchFascicoloModalComponent } from './modals/search-fascicolo-modal/search-fascicolo-modal.component';
import { SearchRichiedenteModalComponent } from './modals/search-richiedente-modal/search-richiedente-modal.component';
import { SearchIntestatarioModalComponent } from './modals/search-intestatario-modal/search-intestatario-modal.component';
import { RichiestaIntegrazioneModalComponent } from './modals/richiesta-integrazione-modal/richiesta-integrazione-modal.component';
import { AddTipoAllegatoModalComponent } from 'src/app/core/modals/add-tipo-allegato-modal/add-tipo-allegato-modal.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { QuillModule } from 'ngx-quill';
import { RichiestaIntegrazioneNewModalComponent } from './modals/richiesta-integrazione-new-modal/richiesta-integrazione-new-modal.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@NgModule({
    declarations: [
        PageNotFoundComponent,
        ErrorPageComponent,
        BadgeComponent,
        ButtonComponent,
        SidebarComponent,
        TableComponent,
        FileUploadComponent,
        BorderedContainerComponent,
        SnackbarComponent,
        ErrorFormDirective,
        ControlErrorContainerDirective,
        ControlErrorComponent,
        MessageModalComponent,
        AlertModalComponent,
        PaginatorComponent,
        GeneralConfirmModalComponent,
        GeneralEmailModalComponent,
        GeneralTextareaModalComponent,
        SearchFascicoloModalComponent,
        SearchRichiedenteModalComponent,
        SearchIntestatarioModalComponent,
        SearchCarpettaModalComponent,
        SearchDocumentoProtocollatoModalComponent,
        RichiestaIntegrazioneModalComponent,
        RichiestaIntegrazioneNewModalComponent,
        AddTipoAllegatoModalComponent,
        LoadingTemplateComponent,
        LoadingDirective,
        ProcedureAccordionsHeaderPipe,
        AssegnazioneIstruttoreModalComponent,
        RimandaInIstruttoriaModalComponent,
        RichiestaIntegrazioneNewModalComponent,
        PrivacyGaranteInfanziaModalComponent,
        PrivacyGaranteDetenutiModalComponent,
        PrivacyGenericoModalComponent,
        ItemDossierDetailModalComponent
        ],
    exports: [
        BadgeComponent,
        ButtonComponent,
        SidebarComponent,
        MatDialogModule,
        MatTableModule,
        MatSortModule,
        BorderedContainerComponent,
        SnackbarComponent,
        TranslateModule,
        ErrorFormDirective,
        ControlErrorContainerDirective,
        ControlErrorComponent,
        MessageModalComponent,
        GeneralConfirmModalComponent,
        GeneralEmailModalComponent,
        GeneralTextareaModalComponent,
        SearchFascicoloModalComponent,
        SearchRichiedenteModalComponent,
        SearchIntestatarioModalComponent,
        SearchCarpettaModalComponent,
        SearchDocumentoProtocollatoModalComponent,
        RichiestaIntegrazioneModalComponent,
        RichiestaIntegrazioneNewModalComponent,
        PrivacyGaranteInfanziaModalComponent,
        PrivacyGaranteDetenutiModalComponent,
        PrivacyGenericoModalComponent,
        AddTipoAllegatoModalComponent,
        AlertModalComponent,
        PaginatorComponent,
        LoadingTemplateComponent,
        LoadingDirective,
        ProcedureAccordionsHeaderPipe,
        MatTooltipModule,
        AssegnazioneIstruttoreModalComponent,
        ItemDossierDetailModalComponent
       // FormDefendoModule
    ],
    imports: [
        MatTableModule,
        MatSortModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        HttpClientModule,
        RouterModule,
        MatDialogModule,
        MatIconModule,
        MatSnackBarModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatCheckboxModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        QuillModule.forRoot(),
        MatTooltipModule,
        // FormDefendoModule,
        FontAwesomeModule
    ],
    providers: [
        InteractionService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
        SnackbarService
    ],
    entryComponents: [
        SnackbarComponent,
        LoadingTemplateComponent
    ]
})
export class CoreModule {
}

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './public/api/assets/i18n/', '.json');
}
